const PHONE_DIGITS_LENGTH_WITH_PLUS = 12;
const RU_PHONE_DIGITS_LENGTH = 11;
const RU_MOBILE_PREFIX = '+79';
const LEGACY_RU_PREFIX = '8';
const LOCAL_MOBILE_LENGTH = 10;

export const formatUserPhoneForChecker = (value: string): string | undefined => {
  const digits = value.replace(/\D/g, '');

  if (!digits) {
    return undefined;
  }

  let normalized = digits;

  if (normalized.length === RU_PHONE_DIGITS_LENGTH && normalized.startsWith(LEGACY_RU_PREFIX)) {
    normalized = `+7${normalized.slice(1)}`;
  }

  if (normalized.length === LOCAL_MOBILE_LENGTH && normalized.startsWith('9')) {
    normalized = `+7${normalized}`;
  }

  if (!normalized.startsWith('+')) {
    normalized = `+${normalized}`;
  }

  const isValidLength = normalized.length === PHONE_DIGITS_LENGTH_WITH_PLUS;
  const isValidPrefix = normalized.startsWith(RU_MOBILE_PREFIX);

  if (!isValidLength || !isValidPrefix) {
    return undefined;
  }


  return normalized;
};
